import React, { useCallback, useState } from 'react';
import{ DataGridTypes,} from 'devextreme-react/data-grid';
import DropDownBox, { DropDownBoxTypes } from 'devextreme-react/drop-down-box';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';

const dropDownOptions = { width: 500 };
const ownerLabel = { 'aria-label': 'Owner' };

const ProductDropDownBoxComponent = (props: any) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([props.data.value]);
  const [isDropDownOpened, setDropDownOpened] = useState(false);

  const boxOptionChanged = useCallback((e: DropDownBoxTypes.OptionChangedEvent) => {
    if (e.name === 'opened') {
      setDropDownOpened(e.value);
    }
  }, []);

  const contentRender = useCallback(() => {
    const onSelectionChanged = (args: DataGridTypes.SelectionChangedEvent) => {
      setSelectedRowKeys(args.selectedRowKeys);
      if (args.selectedRowKeys.length > 0) { setDropDownOpened(false); }
      props.data.setValue(args.selectedRowKeys[0]);
    };

    return (
      <DataGridWrapper
        datasource={props.data.column.lookup.dataSource}
        props={{ selectedRowKeys: selectedRowKeys, focusedRowEnabled: true, defaultFocusedRowKey: selectedRowKeys[0] }}
        onSelectionChanged={onSelectionChanged}  
        pagerVisible={true}
        filterVisible={true}
        headerFilterVisible={false}
        remoteOperations={true}
        selectionConfig={{ mode: 'single' }}
        height={400}
        editingConfig={{
          allowDeleting: false,
          allowUpdating: false,
          allowAdding: false
        }}
        columns={[
          {
            dataField: "productCode",
            caption: "Product Code"
          },
          {
            dataField: "name",
            caption: "Product Name"
          }
        ]}

      />
    );
  }, [props.data, selectedRowKeys]);

  return (
    <DropDownBox
      onOptionChanged={boxOptionChanged}
      opened={isDropDownOpened}
      dropDownOptions={dropDownOptions}
      dataSource={props.data.column.lookup.dataSource}
      value={selectedRowKeys[0]}
      displayExpr="productCode"
      valueExpr="productCode"
      inputAttr={ownerLabel}
      contentRender={contentRender}>
    </DropDownBox>
  );
};

export default ProductDropDownBoxComponent;
